/**
 *@prettier
 */

/**
 * This method searches the browser's URL for the query string for a
 * key=value pair with the provided key. If found, returns the value
 *
 * @method getQueryParam
 * @param {String} sName Key name to find the value for
 * @returns {String} Returns the string value corresponding to the key or false
 */
function getQueryParam(sName) {
  var match = new RegExp("[?&]" + sName + "=([^&]*)").exec(
    window.location.search
  );
  return match && decodeURIComponent(match[1].replace(/\+/g, " "));
}

/**
 * Proxy for console.log that wraps execution in a conditional against
 * a query param
 *
 * @method conlog
 * @returns none
 */
function conlog() {
  var args = Array.prototype.slice.call(arguments);
  var debug = getQueryParam("debug") === "true";
  var onlystrings = true;

  if (debug) {
    // If only one object was passed, just log that out
    if (args.length === 1) {
      // If the object is a string, log it
      if (typeof args[0] === "string") {
        console.log(args[0]);
      }
      // Otherwise, structure the output with dir()
      else {
        console.dir(args[0]);
      }
    } else {
      // check to see if only strings were passed
      for (i = 0; i < args.length; i++) {
        if (typeof args[i] !== "string") {
          onlystrings = false;
        }
      }

      // If the passed arguments are all strings, log them out
      if (onlystrings) {
        console.log(
          args
            .reduce(function (out, item) {
              out.push(item);
              return out;
            }, [])
            .join(", ")
        );
      }
      // Otherwise, structure the output with dir()
      else {
        console.dir(args);
      }
    }
  }
}

module.exports.getQueryParam = getQueryParam;
module.exports.conlog = conlog;
